import React from "react";

const { Provider, Consumer } = React.createContext();

export { Provider as ContainerProvider };
export { Consumer as ItemContainerConsumer };
